import { GlobalStyles } from '@mui/material';

export const PRINT_TARGET_ID = 'groups-print-target';

// Print-only styles for the Groups list. Mirrors the Roster pattern:
// strip dark-theme chrome, force black-on-white inside the print target,
// and let the table flow edge-to-edge on the printed page (the @page
// margin is the only padding around the table).
export const groupsPrintStyles = (
  <GlobalStyles
    styles={{
      '@media print': {
        '@page': { size: 'letter portrait', margin: '0.35in' },
        body: { backgroundColor: 'white !important' },
        [`#${PRINT_TARGET_ID}, #${PRINT_TARGET_ID} *`]: {
          color: 'black !important',
        },
        [`#${PRINT_TARGET_ID}.MuiCard-root, #${PRINT_TARGET_ID} .MuiPaper-root`]:
          {
            backgroundColor: 'white !important',
            backgroundImage: 'none !important',
            boxShadow: 'none !important',
            border: 'none !important',
            borderRadius: '0 !important',
          },
        [`#${PRINT_TARGET_ID} .MuiCardContent-root`]: {
          padding: '0 !important',
        },
        [`#${PRINT_TARGET_ID} .MuiTableCell-root`]: {
          borderColor: 'black !important',
        },
      },
    }}
  />
);
